import { render, staticRenderFns } from "./ControlCurrency.vue?vue&type=template&id=28d317f9&scoped=true&"
import script from "./ControlCurrency.vue?vue&type=script&lang=js&"
export * from "./ControlCurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d317f9",
  null
  
)

export default component.exports